import TotalAmount from './TotalAmount';

export default TotalAmount;
